<div class="main-header pl-4 pr-4 bg-gray-300">
    <div class="grid mt-0">
        <div class="col flex justify-content-center">
            <span class="text-sm text-gray-800" *ngIf="copyrightYear">
                {{ copyrightYear }} Copyright © Touchstone Institute
            </span>
        </div>
    </div>
</div>
